module.exports = __webpack_public_path__ + "img/level_t.d06fb3dd.jpg";